/**
 * Changelog des versions de l'API Netikash
 */

export const changelog = [
    {
        version: 'v1.2.0',
        date: '2024-03-15',
        type: 'feature',
        title: 'Nouvelles fonctionnalités',
        changes: [
            {
                type: 'added',
                description: 'Support des paiements récurrents'
            },
            {
                type: 'added',
                description: 'Nouveau endpoint pour l\'historique des transactions'
            },
            {
                type: 'improved',
                description: 'Amélioration des performances de l\'API de vérification'
            }
        ]
    },
    {
        version: 'v1.1.0',
        date: '2024-02-10',
        type: 'feature',
        title: 'Améliorations et corrections',
        changes: [
            {
                type: 'added',
                description: 'Support de la devise CDF'
            },
            {
                type: 'improved',
                description: 'Documentation des codes d\'erreur enrichie'
            },
            {
                type: 'fixed',
                description: 'Correction d\'un bug dans la gestion des webhooks'
            }
        ]
    },
    {
        version: 'v1.0.0',
        date: '2024-01-01',
        type: 'release',
        title: 'Version initiale',
        changes: [
            {
                type: 'added',
                description: 'Authentification OAuth2'
            },
            {
                type: 'added',
                description: 'Création de demandes de paiement'
            },
            {
                type: 'added',
                description: 'Vérification du statut des paiements'
            },
            {
                type: 'added',
                description: 'Système de webhooks'
            }
        ]
    }
];
